import {
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[pgOption], [gritOption]',
  exportAs: 'pgOption, gritOption',
})
export class PgOptionDirective {
  @Input('gritOption')
  @Input('pgOption')
  pgOption;

  @HostBinding('class.pg-option')
  public _classPgOption = true;
  @HostBinding('class.pg-option-focus')
  public _classPgOptionFocus = false;

  get value() {
    return this.pgOption;
  }

  @Input('display')
  get display() {
    return (
      this.elementRef.nativeElement.innerText ||
      this.elementRef.nativeElement.textContent ||
      this.elementRef.nativeElement.value
    );
  }

  _focused = false;
  @HostBinding('class.pg-option-focused')
  get focused() {
    return this._focused;
  }
  set focused(val: boolean) {
    this._focused = val;
  }

  @Output()
  itemSelected = new EventEmitter<any>();

  constructor(public elementRef: ElementRef) {}

  @HostListener('mouseover')
  onMouseOver() {
    this._classPgOptionFocus = true;
  }

  @HostListener('mouseout')
  onMouseOut() {
    this._classPgOptionFocus = false;
  }

  @HostListener('click')
  onClick() {
    this.itemSelected.emit({
      value: this.value,
      display: this.display,
    });
  }
}
